import * as angular from 'angular';
import './tinymce-wrapper.component.css';

const template = `
<div class="tinymce-wrapper">
    <textarea ui-tinymce="$ctrl.options" ng-model="$ctrl.content"></textarea>
</div>
`;

const tinyMceWrapperConfig = {
    selector: 'mwTinymceWrapper',
    bindings: {
        options: '<',
        content: '='
    },
    template: template,
    controller: null
};

class TinyMceWrapperComponent {
    options: any;
    content: any;
    defaultOptions: any;
    editorLanguageMap: any;

    constructor() {
        'ngInject';
    }

    $onInit() {
        this.defaultOptions = {
            // DOM
            selector: 'textarea',

            // Plugins
            plugins: 'link textcolor charactercount defaultfont disableshiftenter',

            // Link Plugin config
            link_title: false,
            default_link_target: "_blank",
            target_list: false,

            // Editor
            toolbar: 'fontselect | fontsizeselect | forecolor | bold italic underline | link',
            font_formats: 'Sans Serif=helvetica,sans-serif;Serif=times new roman,times,serif;Fixed Width=monospace;Comic Sans MS=comic sans ms,sans-serif;Garamond=garamond,serif;Georgia=georgia,serif;Tahoma=tahoma,arial,helvetica,sans-serif;Trebuchet MS=trebuchet ms,geneva;Verdana=verdana,geneva',
            fontsize_formats: '10px 11px 12px 13px 14px 15px 16px 18px 24px 36px',
            height: '300px',
            menubar: false,
            branding: false,
            statusbar: true,
            resize: false,
            language: 'en',

            // Content
            invalid_elements : 'br',

            // Skin
            content_css: '/js/lib/tinymce/content.css',
            skin: 'meltwater2.0',
            theme : 'modern',

            // Custom
            limit: 3000,
            defaultFontName: 'helvetica,sans-serif',
            defaultFontSize: '14px'
        };

        this.editorLanguageMap = {
            da: 'da',     // danish
            de: 'de',     // german
            en: 'en_US',  // english (default)
            es: 'es',     // spanish
            fi: 'fi',     // finnish
            fr: 'fr_FR',  // french
            ja: 'ja',     // japanese
            nb: 'nb_NO',  // norwegian
            nl: 'nl',     // dutch
            pt: 'pt_PT',  // portuguese
            sv: 'sv_SE',  // swedish
            /* jshint camelcase: false */
            zh_CN: 'zh_CN',   // chinese (simplified)
            /* jshint camelcase: false */
            zh_TW: 'zh_TW'    // chinese (traditional)
        };

        this.options = angular.extend({}, this.defaultOptions, this.options);
        this.options.language = this.editorLanguageMap.hasOwnProperty(this.options.language) ? this.editorLanguageMap[this.options.language] : 'en_US';
    }
}

tinyMceWrapperConfig.controller = TinyMceWrapperComponent;

export {
    tinyMceWrapperConfig,
    TinyMceWrapperComponent as default
};



/** WEBPACK FOOTER **
 ** ./apps-ts/outputs/src/app/wysiwyg/tinymce/component/tinymce-wrapper.component.ts
 **/